import { DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';
import {
  OpenWidgetCommand,
  TeiaViewer,
  ToolbarItem,
  useViewerContext,
  useWidgetInfo,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { DocumentViewerWidgetProps } from './widgets/DocumentViewerWidget';

export const ShowDocumentViewerWidget = (props: DocumentViewerWidgetProps) => {
  const { documentViewerProps, title } = props;
  const { t } = usePluginTranslation();
  const { viewer } = useViewerContext<TeiaViewer>();
  const { isOpened } = useWidgetInfo('DocumentViewer');

  const onClick = () => {
    const command = new OpenWidgetCommand(viewer, 'DocumentViewer', {
      documentViewerProps,
      title,
    });
    command.execute();
  };

  return (
    <ToolbarItem
      icon={DocumentMagnifyingGlassIcon}
      onClick={onClick}
      label={t('toolbar.document_viewer.tooltip')}
      data-dd-action-name="toolbar.document_viewer"
      active={isOpened}
    />
  );
};
